import { Panel, VerticalContainer } from '@/components';
import { InfoIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

export const AiJournalNoteNotSupportedView = () => {
    return (
        <Panel className="bg-(--color-bg-subtle)">
            <VerticalContainer>
                <InfoIcon variant="default" />
                <p>{R.AiJournalNoteNotSupported}</p>
            </VerticalContainer>
        </Panel>
    );
};
